import React from 'react';
import "./asn1-render.css"
import { useTranslation } from "react-i18next"

const Asn1DataTable = ({ data = [] }) => {
    const { t } = useTranslation()
    return (
        <div>
            {data.map((variable, index) => (
                <div className='digitalVaultDocumentAsn1' key={index}>
                    <table>
                        <div className='digitalVaultDocumentAsn1Title'>
                            {t("asn1Fields.label.metadata")}
                        </div>
                        <tbody>
                            <tr>
                                <td className="digitalVault-label">{t("asn1Fields.label.locality")}:</td>
                                <td>{variable.localityName}</td>
                            </tr>
                            <tr>
                                <td className="digitalVault-label">{t("asn1Fields.label.stateOrProvince")}:</td>
                                <td>{variable.stateOrProvinceName}</td>
                            </tr>
                            <tr>
                                <td className="digitalVault-label">{t("asn1Fields.label.country")}:</td>
                                <td>{variable.countryName}</td>
                            </tr>
                            <tr>
                                <td className="digitalVault-label">{t("asn1Fields.label.postalCode")}:</td>
                                <td>
                                    {variable.postalCode?.map((code, i) => (
                                        <div key={i}>{code}</div>
                                    ))}
                                </td>
                            </tr>
                            <tr>
                                <td className="digitalVault-label">{t("asn1Fields.label.address")}:</td>
                                <td>
                                    {variable.streetAddress?.map((addr, i) => (
                                        <div key={i}>{addr}</div>
                                    ))}
                                </td>
                            </tr>
                            <tr>
                                <td className='digitalVaultDocumentTr' colSpan="2"><hr style={{ border: 'none', borderTop: '1px solid #ccc', width: '100%' }} /></td>
                            </tr>
                            <tr>
                                <td className="digitalVault-label">{t("asn1Fields.label.commonName")}:</td>
                                <td>
                                    {variable.commonName?.map((name, i) => (
                                        <div key={i}>{name}</div>
                                    ))}
                                </td>
                            </tr>
                            <tr>
                                <td className="digitalVault-label">{t("asn1Fields.label.organizationalUnit")}:</td>
                                <td>
                                    {variable.organizationalUnitName?.map((unit, i) => (
                                        <div key={i}>{unit}</div>
                                    ))}
                                </td>
                            </tr>
                            <tr>
                                <td className="digitalVault-label">{t("asn1Fields.label.organization")}:</td>
                                <td>
                                    {variable.organizationName?.map((org, i) => (
                                        <div key={i}>{org}</div>
                                    ))}
                                </td>
                            </tr>
                            <tr>
                                <td className="digitalVault-label">{t("asn1Fields.label.email")}:</td>
                                <td>
                                    {variable.emailAddress?.map((email, i) => (
                                        <div key={i}>{email}</div>
                                    ))}
                                </td>
                            </tr>
                            <tr>
                                <td className='digitalVaultDocumentTr' colSpan="2"><hr style={{ border: 'none', borderTop: '1px solid #ccc', width: '100%' }} /></td>
                            </tr>
                            <tr>
                                <td className="digitalVault-label">{t("asn1Fields.label.crl")}:</td>
                                <td>{variable.cRLDistributionPoints}</td>
                            </tr>
                            <tr>
                                <td className="digitalVault-label">{t("asn1Fields.label.certificatePolicies")}:</td>
                                <td>{variable.certificatePolicies}</td>
                            </tr>
                            <tr>
                                <td className="digitalVault-label">{t("asn1Fields.label.pscTimeValidated")}:</td>
                                <td>
                                    {variable.pscTimeValidated?.map((time, i) => (
                                        <div key={i}>{time}</div>
                                    ))}
                                </td>
                            </tr>
                            <tr>
                                <td className="digitalVault-label">{t("asn1Fields.label.signingTime")}:</td>
                                <td>{variable.signingTime}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            ))}
        </div>
    );
};

export default Asn1DataTable;

